<template lang="pug" src="./template/RetailersFilter.pug"></template>
<style lang="stylus" src="./styles/RetailersFilter.styl" scoped></style>

<script>
export default {
    data() {
        return {
            retailers: [],
            show: false,
        };
    },

    async mounted() {
        this.retailers = await this.getRetailers();
    },

    methods: {
        async getRetailers() {
            const response = await window.axios.get('/api/retailers/');
            return response.data.data;
        },
        toggleRetailersFilter(retailerName) {
            this.$store.dispatch('toggleRetailersFilter', retailerName);
            this.$store.dispatch('debounceDeals');
        },
    },
};
</script>


